import { createContext } from 'react';
import { Organization } from '../types/Organization'

export const OrganizationContext = createContext<Organization>({
    displayName: '',
    name: ''
});